import { DEFAULT_LOCALE } from 'constants/locales'
import numbro from 'numbro'

export const floorFormatter = (n: number): string => {
  if (n === 0) return '0.00'
  if (!n) return ''
  if (n < 0.001) {
    return '<0.001'
  }
  if (n >= 0.001 && n < 1) {
    return `${parseFloat(n.toFixed(3)).toLocaleString(DEFAULT_LOCALE, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 3,
    })}`
  }
  if (n >= 1 && n < 1e6) {
    return `${parseFloat(n.toPrecision(6)).toLocaleString(DEFAULT_LOCALE, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })}`
  }
  if (n >= 1e6 && n < 1e15) {
    return numbro(n)
      .format({
        average: true,
        mantissa: 2,
        optionalMantissa: true,
        abbreviations: {
          million: 'M',
          billion: 'B',
          trillion: 'T',
        },
      })
      .toUpperCase()
  }
  if (n >= 1e15) {
    return `${n.toExponential(3).replace(/(\.[0-9]*[1-9])0*|(\.0*)/, '$1')}`
  }
  return `${Number(n.toFixed(2)).toLocaleString(DEFAULT_LOCALE, { minimumFractionDigits: 2 })}`
}

export const quantityFormatter = (n: number): string => {
  if (n === 0) return '0.00'
  if (!n) return ''
  if (n >= 1 && n < 1000) {
    return `${Number(Math.round(n).toLocaleString(DEFAULT_LOCALE))}`
  }
  if (n >= 1000) {
    return numbro(n)
      .format({
        average: true,
        mantissa: 1,
        thousandSeparated: true,
        optionalMantissa: true,
        abbreviations: {
          thousand: 'K',
          million: 'M',
          billion: 'B',
          trillion: 'T',
        },
      })
      .toUpperCase()
  }
  return `${Number(n.toFixed(2)).toLocaleString(DEFAULT_LOCALE, { minimumFractionDigits: 2 })}`
}

export const numberFormatter = (num: number): string => {
  const abbreviations = ['', 'K', 'M', 'B', 'T']
  let abbreviatedNum = num
  let abbreviationIndex = 0

  while (abbreviatedNum >= 1000) {
    abbreviatedNum /= 1000
    abbreviationIndex++
  }

  if (abbreviationIndex > 0 && abbreviationIndex < abbreviations.length) {
    return `${abbreviatedNum.toFixed(2)}${abbreviations[abbreviationIndex]}`
  } else {
    return parseFloat(num.toString()).toFixed(0)
  }
}

export const formatAmount = (num: number | undefined, digits = 2) => {
  if (num === 0) return '0'
  if (!num) return '-'
  if (num < 0.001) {
    return '<0.001'
  }
  return numbro(num).format({
    average: true,
    mantissa: num > 1000 ? 2 : digits,
    abbreviations: {
      million: 'M',
      billion: 'B',
    },
  })
}
